var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_success",
    "data-name": "icona success",
    transform: "translate(-535 -899)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_17",
    "data-name": "Ellisse 17",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(535 899)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-icon",
    d: "M16,9,9.125,15.875,6,12.75",
    transform: "translate(535.5 897.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5491beec1d6e0585565f084f6299dbfc.svg";
export { ForwardRef as ReactComponent };